export enum ProjectSaleType {
  Direct = 1,
  Distribution = 2,
  International = 3,
}
